export default "__VITE_ASSET__CFxad4sG__"